export default {
	data() {
		return {
			operators: [],
			businessModels: [],
		}
	},
	computed: {
		operatorOptions() {
			if (this.operators) {
				return this._.map(this.operators, function (item) {
					return {id: item['id'], text: item['name']}
				})
			}
		},
		businessModelOptions() {
			if (this.businessModels) {
				return this._.map(this.businessModels, function (item) {
					return {id: item['id'], text: item['name']}
				})
			}
		},
		multiBusinessModelOptions() {
			if (this.businessModels) {
				return this._.map(this.businessModels, function (item) {
					return {value: item['id'], text: item['name']}
				})
			}
		},
		businessModelSingle: {
			get() {
				return this.entity.id_business_models[0]
			},
			set(newValue) {
				this.entity.id_business_models = [newValue]
			}
		}
	},
	methods: {
		getOperatorsAndBusinessModelsAndSetIdsToEntity(prependOperators = false, prependBusinessModels = false) {
			return this.getOperatorsAndSetIdOperatorToEntity(prependOperators, prependBusinessModels)
				.then(() => {
					this.getBusinessModels(prependBusinessModels)
						.then(() => {
							this.setBusinessModelByOperatorId(this.entity.id_operator)
						})
				})
		},
		getOperatorsAndBusinessModels(prependOperators = false, prependBusinessModels = false) {
			return this.getOperators(prependOperators)
				.then(() => {
					this.getBusinessModels(prependBusinessModels)
				})
		},
		getOperatorsAndSetIdOperatorToEntity(prepend = false) {
			return this.getOperators(prepend)
				.then(() => {
					let selectedSingleOperator = this.$_loggedUser_selectedOperatorId;

					if (prepend) {
						this.entity['id_operator'] = selectedSingleOperator ? selectedSingleOperator : '0'
					} else {
						this.entity['id_operator'] = selectedSingleOperator ? selectedSingleOperator : this.$_loggedUser_operatorId
					}
				})
		},
		getOperators(prepend = false, nullOperator = false) {
			this.setLoadingMessage()
			return this.operatorService.getOperators()
				.then(data => {
					if (prepend) {
						this.operators = [{'id': nullOperator? null : '0', 'name': this.$gettext('Nenastaven')}, ...data['operators']];
					} else {
						this.operators = data['operators']
					}
					this.emptyMessage()
				})
				.catch(error => {
					this.setErrorMessage(error['error_message'])
				})
		},
		getBusinessModels(prepend = false) {
			this.setLoadingMessage()
			return this.businessModelService.getEntities()
				.then(data => {
					if (prepend) {
						this.businessModels = [{'id': '0', 'name': this.$gettext('Nenastaven')}, ...data['business_models']];
					} else {
						this.businessModels = data['business_models']
					}
					this.emptyMessage()
				})
				.catch(error => {
					this.setErrorMessage(error['error_message'])
				})
		},
		setBusinessModelByOperatorId(operatorId, multi = false) {
			if (operatorId > 0) {
				let newBusinessModelId = null
				this._.forEach(this.operators, function (operator) {
					if (Number(operator.id) === Number(operatorId)) {
						newBusinessModelId = operator.id_business_model
					}
				})

				if (multi) {
					this.entity.id_business_models = [newBusinessModelId]
				} else {
					this.entity.id_business_model = newBusinessModelId
				}
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/select-operator-business-model.js